import { LensPageProps } from "@snapchat/content-platform-www/generated-src/snapchat/web/stories/props";
import { fetchProps } from "@snapchat/web-proto-props";
import { incrementCounter } from "@snapchat/web-graphene-reporting";
import { useEffect, useMemo } from "react";
import { LensProfile } from "../../components/profile/LensProfile";
import { FALLBACK_ORIGIN } from "../../constants/endpoints";
import { grafanaBasePrefix } from "../../lib/grafana";
import { Locale, useLocale } from "@snapchat/web-i18n";
import { loadMessages } from "../../i18n/messages";
import { WWW_DOT_SNAPCHAT_DOT_COM_GA } from "@snapchat/web-analytics-types";
import { IntlProvider } from "react-intl";
const LensPage = (props) => {
    const { locale, messages, changeLocale } = useLocale({
        defaultLocale: props.viewerInfo?.locale,
        defaultMessages: props.messages,
        loadMessages,
    });
    const localizedViewerInfo = useMemo(() => ({
        ...(props.viewerInfo ?? {}),
        locale,
    }), [props.viewerInfo, locale]);
    useEffect(() => {
        void incrementCounter(`${grafanaBasePrefix}.LensProfile.PageView`, 1);
    }, []);
    return (<IntlProvider locale={locale} messages={messages} defaultLocale={Locale.enUS}>
      <LensProfile {...props} viewerInfo={localizedViewerInfo} messages={messages} changeLocale={changeLocale}/>
    </IntlProvider>);
};
/* istanbul ignore next -- cannot test backend functions */
LensPage.getInitialProps = async (ctx) => {
    const props = await fetchProps(ctx.req, LensPageProps, WWW_DOT_SNAPCHAT_DOT_COM_GA, FALLBACK_ORIGIN);
    return {
        ...props,
        skipWebConfigNamespaceProviderInitialization: false,
    };
};
export default LensPage;
